import React from 'react';
import { useTranslation } from "react-i18next";
import BackContainer from './components/backContainer';
import TicketHeader from './components/header';
import ResaleBreakdown from './components/resaleBreakdown';
import './resale.css';


export default function CreateResale({ onSubmit = () => { }, config }) {
    const { t } = useTranslation();
    const { id: attendeeId } = config['resale-ticket-create-form'].header;
    const min = config['resale-ticket-create-form'].resale_breakdown.price.min;
    const max = config['resale-ticket-create-form'].resale_breakdown.price.max;
    const [state, setState] = React.useState({ 'price': min === max ? max : null, 'is_private_resale': false });

    const goToTicket = React.useCallback(() => {
        onSubmit(
            {
                data: {
                    action: 'previous',
                    payload: {
                        attendee_id: attendeeId
                    }
                }
            }
        )
    }
        , [onSubmit, attendeeId]);

    const handleSubmit = React.useCallback(() => {
        onSubmit({
            data: state
        })
    }, [onsubmit, state])

    return (
        <div className='resale-container'>
            <BackContainer title={t('widget.resale.back-title')} onClick={goToTicket} />
            <TicketHeader data={config['resale-ticket-create-form'].header} state={state} />
            <ResaleBreakdown data={config['resale-ticket-create-form']} state={state} setState={setState} mode='create' onSubmit={onSubmit} handleSubmit={handleSubmit} />
        </div>
    )
}